import { PaginaDocument } from '@next-nx/shared-graphql/assicurazioni'
import { SinistroTemplate } from '@next-nx/shared-ui/templates'
import { initializeApollo } from 'apps/next-assicurazioni/client'
import { NextWrapper } from 'apps/next-assicurazioni/data-fetching-wrapper'
import React from 'react'

const SinistroPage = ({ pagina }) => <SinistroTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview = false, previewData }) => {
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : undefined
    const client = initializeApollo()

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        chiave: 'in-caso-di-sinistro',
        preview: preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina }, // will be passed to the page component as props
      revalidate: 60 * 60, // In seconds
    }
  }
)

export default SinistroPage
